import { type SelectedEnergyTypes } from "@/features/subscription/types/selectedEnergyTypes"
import { isMonoEnergy } from "@/features/subscription/utils/isMonoEnergy"

export const formatFunnelEnergyType = (energyType: SelectedEnergyTypes) =>
    isMonoEnergy(energyType) ? energyType[0] : "dual"
